import { render, staticRenderFns } from "./TagSet.vue?vue&type=template&id=74d767a4&"
import script from "./TagSet.vue?vue&type=script&lang=js&"
export * from "./TagSet.vue?vue&type=script&lang=js&"
import style0 from "./TagSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports